/**
 * 推广相关的
 * @author fulh
 * @create 16/7/21.
 */
$.module('MM.union', function () {
  var BRAND_TAG = 'BRAND_MODE';

  function _isBrandMode() {
    var flag = !!($.store.get(BRAND_TAG) || $.query.get('login'));
    $.store.set(BRAND_TAG, flag ? 1 : 0);
    return flag && _isUnion();
  }

  var BRAND_TAG2 = 'BRAND_MODE2';

  function _isBrandMode2() {
    var flag = !!($.store.get(BRAND_TAG2) || $.query.get('login2'));
    $.store.set(BRAND_TAG2, flag ? 1 : 0);
    return flag && _isUnion();
  }

  /**
   * 是否是推广模式
   * @returns {boolean}
   * @private
   */
  function _isUnion() {
    return location.host.indexOf('union.2339.com') > -1;
  }

  /**
   * 判断是否是360浏览器
   */
  function is360() {
    return MM.user.getFrom().indexOf('360') > -1; //判断是否是360渠道来的用户
  }

  return {
    is360: is360,
    isBrandMode: _isBrandMode,
    isBrandMode2: _isBrandMode2,
    isUnion: _isUnion,
  };
});
